/**
 * package: com.inq.ui
 * class: AbstractTextInput
 * @extends com.inq.ui.Container
 * @constructor
 */
com.inq.ui.AbstractTextInput = function(_id) {
	com.inq.ui.Container.call(this,_id);
	this.maxChars = 0;/*  zero is unlimited characters.*/

	if("" == window.document.body.style.fontFamily) try {
		window.document.body.style.fontFamily = com.inq.utils.Util.getConfig("sFont","Verdana, Arial, Helvetica");
		var fontsize = com.inq.utils.Util.getConfig("pointSize",null);
		if(fontsize !== null) {
			window.document.body.style.fontSize = "" + Std.string(fontsize) + "pt";
		}
	} catch( e ) {
		haxe.Log.trace("could not set font family and point size",{ fileName : "AbstractTextInput.hx", lineNumber : 26, className : "com.inq.ui.AbstractTextInput", methodName : "new"});
	}
};
$hxClasses.extend(com.inq.ui.Container, com.inq.ui.AbstractTextInput, "com.inq.ui.AbstractTextInput");

// TODO this should be library
/** @private @type {boolean} */
com.inq.ui.AbstractTextInput._isWindowsChromeWindowsMac = (/(Windows|Linux|Macintosh).*AppleWebKit?.*Chrome/i.test(navigator.userAgent));

/**
 * Determines whether we should use the "placeholder" property of the
 * text input element to specify default text.
 *
 * @returns {boolean}
 *
 * @deprecated Because now we use the feature detection and used HTML5 placeholder if possible.
 */
com.inq.ui.AbstractTextInput.prototype.usePlaceholder = function() {
	return com.inq.utils.Capabilities.isIe10Phone();
};


/**
 * isViewable
 * This is fundimentally different from isVisible
 * If this input field or any parent of the field are not visible
 * then: return false
 * else: return true;
 *
 * $type TFun([{ name => input, t => TDynamic(null), opt => false }],TEnum(Bool,[]))
 * private static function isViewable(input:Dynamic):Bool
 * @private
 * @static
 * @param {Element}  input
 * @return {boolean} - true|false if this or any parent is not visible return false else true
 */
com.inq.ui.AbstractTextInput.isViewable = function(input) {
	/** @type {Element} */
	var p = input;
	while(p != null) {
		try {
			if(p["style"] != null && (p.style.display == "none" || p.style.visible == "false")) return false;
		} catch( e ) {
		}
		p = p.parentNode;
	}
	return true;
};


/**
 * getCursorPosition
 * This function is to get the cursor position of the phone fields.
 * return  the cursor position of the phone field
 *
 * $type TFun([],TInst(Int,[]))
 * public function getCursorPosition():Int
 * @public
 * @this com.inq.ui.AbstractTextInput
 * @return {number}
 */
com.inq.ui.AbstractTextInput.prototype.getCursorPosition = function() {
	if (this._input["createTextRange"] != null && (this.document["selection"] != null && this.document.selection["createRange"])) {
		/** @type {TextRange} */
		var selectionRng = this.document.selection.createRange().duplicate();
		selectionRng.moveEnd("character", StringTools.trim(this._getInput()).length);
		if (selectionRng.text == "") {
			return StringTools.trim(this._getInput()).length;
		}
		return StringTools.trim(this._getInput()).lastIndexOf(selectionRng.text);
	} else return this._input["selectionStart"];
};


/**
 * _enable
 *
 * $type TFun([{ name => val, t => TEnum(Bool,[]), opt => false }],TDynamic(null))
 * private function _enable( val:Bool ):Dynamic
 * @private
 * @this com.inq.ui.AbstractTextInput
 * @param {boolean}  val
 * @return {null}
 */
com.inq.ui.AbstractTextInput.prototype._enable = function(val) {
	if(this._div.childNodes && this._div.childNodes.length > 0) {
		var /** @type {number} */ _g1 = 0, /** @type {number} */ _g = this._div.childNodes.length;
		while(_g1 < _g) {
			var /** @type {number} */ x = _g1++;
			try {
				this._div.childNodes[x].disabled = val;
			} catch( error ) {
			}
		}
	}
};


/**
 * _isDisable
 *
 * $type TFun([],TEnum(Bool,[]))
 * private function _isDisable():Bool
 * @private
 * @this com.inq.ui.AbstractTextInput
 * @return {boolean}
 */
com.inq.ui.AbstractTextInput.prototype._isDisable = function() {
	/** @type {boolean} */
	var isDisabled = true;
	if(this._div.childNodes && this._div.childNodes.length > 0) {
		var /** @type {number} */ _g1 = 0, /** @type {number} */ _g = this._div.childNodes.length;
		while(_g1 < _g) {
			var /** @type {number} */ x = _g1++;
			try {
				isDisabled = isDisabled && !!this._div.childNodes[x].disabled;
			} catch (error) {
			}
		}
	}
	return isDisabled;
};


/**
 * select
 *
 * $type TFun([],TEnum(Void,[]))
 * public function select():Void
 * @public
 * @this com.inq.ui.AbstractTextInput
 * @return {void}
 */
com.inq.ui.AbstractTextInput.prototype.select = function() {
};


/**
 * _setInput
 *
 * $type TFun([{ name => val, t => TInst(String,[]), opt => false }],TDynamic(null))
 * private function _setInput(val:String):Dynamic
 * @private
 * @this com.inq.ui.AbstractTextInput
 * @param {string} val
 * @param {string=} previousVal - optional parameter to save the previous value to restore it later
 * @return {null}
 */
com.inq.ui.AbstractTextInput.prototype._setInput = function(val, previousVal) {
	if (com.inq.utils.Capabilities.isWindowsPhone()) {
		if (this.pendingTimer) {
			this.pendingValue = val; // Already-queued function will use this value.
		}
		else {
			var self = this;
			this.pendingValue = val;
			this.pendingTimer = com.inq.utils.Timer.delay(function () {
				if (self.setText) {
					self.setText(val, previousVal);
				} else {
					self._input.value = self.pendingValue;
				}
				self.pendingTimer = null;
				self.pendingValue = null;
			}, 1);
		}
	}
	else {
		// "setText" method is added when "this" - it is an instance of TextInput
		if (this.setText) {
			this.setText(val, previousVal);
		} else {
			this._input.value = val;
		}
	}
};

/**
 * Clear the contents of the input field.
 */
com.inq.ui.AbstractTextInput.prototype.clear = function() {
	this._setInput("", "");
};


/**
 * _getInput
 *
 * $type TFun([],TInst(String,[]))
 * private function _getInput():String
 * @private
 * @this com.inq.ui.AbstractTextInput
 * @return {string}
 */
com.inq.ui.AbstractTextInput.prototype._getInput = function() {
	if (com.inq.utils.Capabilities.isWindowsPhone()) {
		if(this.pendingTimer) {
			return this.pendingValue;
		}
	}
	return this._input.value;
};


/**
 * setFocus
 *
 * SPECIAL NOTE: On mobile, setting focus programatically does NOT bring up the virtual keyboard.
 *               Only by setting focus with a finger brings up the keyboard.  So we do not set focus programatically.
 *               Please see RTDEV-6610
 *
 * @see http://jira.touchcommerce.com/browse/RTDEV-6610
 * override 	public function setFocus():Void
 * @override
 * @public
 * @param force (OPTIONAL) Force focus into the text input? (See RTDEV-6773.)
 * @this com.inq.ui.AbstractTextInput
 * @return {void}
 */
com.inq.ui.AbstractTextInput.prototype.setFocus = function(force) {
	if (com.inq.utils.Capabilities.isIphone() && !force) {
		return;
	}
	else if (com.inq.utils.Capabilities.isIe10Phone() && !force) {
		return;
	} else if(!com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.isTouched
		&& ((com.inq.utils.Capabilities.isSafari() && com.inq.utils.Capabilities.isTablet()) || com.inq.utils.Capabilities.isChromeiOS10() || com.inq.utils.Capabilities.isChromeiOS11())
        && !force) {
		return;
	}
	else if(com.inq.flash.client.control.FlashPeer.getIsBuilder() && !com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.isTouched) {
		return;
	}

	// if mobile and if orientation is not portrait (meaning it is landscape) and this skin has the smallScreenMsg msq
	// we do not want to focus input because it may bring up the keyboard
	if (com.inq.utils.Capabilities.isPhone() && !com.inq.utils.Capabilities.getOrientation() && Application.application.getCanvas("smallScreenMsg") != null) {
		return;
	}

	if (com.inq.ui.AbstractTextInput.isViewable(this._input) && !this._isDisable()) {
        /* IE is sensitive to setting focus to a non-visible or disabled entity
	     * It alerts EVEN IF try/catch is in place
	     * "Can't move focus to the control because it is invisible, not enabled, or of a type that does not accept the focus"
	     */
	    try {
			/** @type {HTMLElement}*/
			var inputElement = this._input ;
			if (inputElement) {

				/* If we are Chrome on Windows, then we will fix the positioning problem.
					We will NOT:
					   1) get the scroll position before focus
					   2) set focus
					   3) If changed, then position the scroll back to where it was before focus
					The above had a timing issue of when the scroll takes place.
					The better solution is to avoid the scrolling issue.

					We know that this is an issue with Chrome V39 (and above, including V42) and it is on Windows, Linux, and Mac.
					Please see chromium trouble ticket: https://code.google.com/p/chromium/issues/detail?id=437025

					A better approach to fixing this is to avoid the scrolling completely

					Chromium issue #437025 states:
							Steps to reproduce the problem:
								1. Have an iframe completely within but near the bottom of the visible content, containing a input element with some selected text inside (as in the attached html file).
					and I (fpinn@touchcommerce.com) have verified this and it is true.

					If the text box is in the lower hemisphere of the browser window, we scroll down.  If it is not, then no scroll issue.

					So the solution (and is this a real cludge) is to, at the time of focus,
						1) retrieve and save the chat box coordinates
						2) move the chat box to the upper left corner and limiting the size
						3) do the focus
						4) restore the chat box coordinates

				*/
				/**
				 * This if construct should not be executing for Android chrome but because of the regex matching android chrome browser this gets executed and causing re render every time send button is
				 * touched.
				 * Also causes accessibility focus goes to parent page during re render.
				 */
				if (com.inq.ui.AbstractTextInput._isWindowsChromeWindowsMac && !com.inq.utils.Capabilities.isAndroidWebView()) {
					/* RTDEV-7505: Dixons - Initiation of chat window causes browser to scroll to bottom right of page in Chrome v 39
					   Chrome on Windows has a bug in it when it comes to setting focus
					   when an input field gets focus, it can scroll
					   This causes a scrolling down of the client page!

					   I think this is so on Windows 8 there can be a virtual keyboard
					*/
					/** @type {Window} */
					var clientWin = window.top;
					/* get the scroll position before focus */
					/** @type {number} */
					var scrollTop = clientWin.scrollY ;
					/** @type {number} */
					var scrollLeft = clientWin.scrollX;

					/* 1) Save coordinates of the stage */
					var _area = Application.GetArea();
					/** @type {string} */
					var stageStyles = Application.application._div.style.cssText;					/* Save the current style for the stage */
					/* 2) Now reposition to the top/left. one pixel by one pixel */
					Application.application._div.style.cssText = "position: absolute; top: "  +scrollTop+ "px; right: " +scrollLeft+ "px; height: 1px; width: 1px;display: block;";
					/* 3) do the focus if not minimized */
					if (!com.inq.flash.client.control.MinimizeManager.isMinimized()) {
						/* 4) restore the chat box coordinates */
						Application.application._div.style.cssText = stageStyles;
						Application.MoveSizeDiv2Stage(_area.w, _area.h, _area.x, _area.y);

						if(top.document.activeElement != inputElement || force) {
							inputElement.focus();
						}
					}
				}
				else {
					if(top.document.activeElement != inputElement || force) {
						/*RTDEV-20027: For IE, a setTimeout() is required for the CATO to work because the elements are loaded differently for IE*/
						if (com.inq.utils.Util.isIE) {
							window.setTimeout(function() {
								inputElement.focus();
							}, 500);
						} else {
							inputElement.focus();
						}
					}
				}

				/** @type {Document} */
				var doc = inputElement.ownerDocument ;		// get the document associated with the input element
				/* If we are unsuccessful in setting focus, then do it in a timer */
				if (doc.activeElement !== inputElement) {							// Success ??? We compareDocumentPosition the activeElement to the input element that we just focused */
		          if (typeof Application.application.setFocusTimeout == "undefined" || Application.application.setFocusTimeout === false) {
		          	// prevent race condition with other input setFocus calls by flagging this timeout
		            Application.application.setFocusTimeout = window.setTimeout(function() {
		              if (top.document.activeElement != inputElement) {
		                inputElement.focus();
		              }
		              // clear the flag
		              Application.application.setFocusTimeout = false;
		            }, 1);
		          }
				}
			}
	    } catch( e ) {
			haxe.Log.trace("ERROR: Could not set focus",{ fileName : "AbstractTextInput.js", lineNumber : 200, className : "com.inq.ui.AbstractTextInput", methodName : "setFocus"});
	    }
    }
};



/**
 * setID
 *
 * $type TFun([{ name => val, t => TInst(String,[]), opt => false }],TEnum(Void,[]))
 * override  public function setID(val:String):Void
 * @override
 * @public
 * @this com.inq.ui.AbstractTextInput
 * @param {string}  val
 * @return {void}
 */
com.inq.ui.AbstractTextInput.prototype.setID = function(val) {
	com.inq.ui.Container.prototype.setID.call(this,val);
	if(this._input != null) this._input.id = Std.string(this._div.id) + "_input";
};


/**
 * _onKey
 *
 * $type TFun([{ name => ev, t => TAnonymous(<anonymous>), opt => false },{ name => kev, t => TInst(String,[]), opt => false }],TEnum(Bool,[]))
 * private function _onKey(ev, kev:String):Bool
 * @private
 * @this com.inq.ui.AbstractTextInput
 * @param {TAnonymous(<anonymous>)}  ev
 * @param {string}  kev
 * @return {boolean}
 */
com.inq.ui.AbstractTextInput.prototype._onKey = function (ev,kev) {
	/** @type {com.inq.events.KeyboardEvent} */
	var kbe = new com.inq.events.KeyboardEvent(kev);

	if (null != ev) {
		kbe.keyCode = ev.which;
	} else {
		kbe.keyCode = Application.application.getPanelWindow().event.keyCode;
	}
	return this.dispatchEvent(kbe);
};


/**
 * _onInput
 */
com.inq.ui.AbstractTextInput.prototype._onInput = function(ev) {
	this.dispatchEvent(ev);
	if (this.textPasted) {
		this._setInput(this.applyFilter(this._getInput()));
		this.textPasted = false;
	}
};

/**
 * _onKeyPress
 *
 * @private
 * @this com.inq.ui.AbstractTextInput
 * @param   evt
 * @return {boolean}
 */
com.inq.ui.AbstractTextInput.prototype._onKeyPress = function (evt) {
	/** @type {com.inq.events.KeyboardEvent} */
	var keyEvt = new com.inq.events.KeyboardEvent(com.inq.events.KeyboardEvent.KEY_PRESS);

	// FF supports only which property and other browsers support both.
	keyEvt.keyCode = (null != evt) ? evt.which : Application.application.getPanelWindow().event.keyCode;
	keyEvt.charCode = (null != evt) ? evt.which : Application.application.getPanelWindow().event.charCode;
	keyEvt.ctrlKey = (null != evt) ? evt.ctrlKey : !!Application.application.getPanelWindow().event.ctrlKey;
	keyEvt.altKey = (null != evt) ? evt.altKey : !!Application.application.getPanelWindow().event.altKey;
	keyEvt.shiftKey = (null != evt) ? evt.shiftKey : !!Application.application.getPanelWindow().event.shiftKey;

	keyEvt.charCode = keyEvt.keyCode = (keyEvt.charCode || keyEvt.keyCode);

	if (keyEvt.ctrlKey || keyEvt.keyCode < 32) {
		return this.dispatchEvent(keyEvt);
	}

	var sMaxChars = this.getStyle("maxChars");
	this.maxChars = (sMaxChars != null) ? Std.parseInt(sMaxChars) : 0;
	if (this.maxChars > 0) {
		var len = this._getInput().length - this._getSelectedText().length;
		if (len >= this.maxChars) {
			return false;
		}
	}

	var sRestrict = this.getStyle("restrict");
	if (sRestrict != null) {
		var character = String.fromCharCode(keyEvt.keyCode);
		if (sRestrict.indexOf(character) < 0) {
			return false;
		}
	}

	return this.dispatchEvent(keyEvt);
};


/**
 * validateAndFormat
 *
 * $type TFun([],TEnum(Bool,[]))
 * private function validateAndFormat():Bool
 * @private
 * @this com.inq.ui.AbstractTextInput
 * @return {boolean}
 */
com.inq.ui.AbstractTextInput.prototype.validateAndFormat = function() {
	var result = true;
	/** @type {string} */
	var text = this._getInput() ? this.applyFilter(this._getInput()) : null;
	if (text) {
		/** @type {?string} */
		var validate = this.getStyle("validate");
		if (validate) {
			/** @type {EReg} */
			var rex = new EReg(validate, "");
			if (!rex.match(text)) {
				this.setFocus();
				result = false;
			}
		}
		/** @type {?string} */
		var format = this.getStyle("format");
		if (format != null) {
			text = rex.replace(text, format);
		}
		this._setInput(text);
	}
	return result;
};


/**
 * _isVisible
 * is this control visible ?
 * Check this element and all parent elements for display=="none"
 *
 * $type TFun([],TEnum(Bool,[]))
 * private function _isVisible():Bool
 * @private
 * @this com.inq.ui.AbstractTextInput
 * @return {boolean}
 */
com.inq.ui.AbstractTextInput.prototype._isVisible = function() {
	/** @type {HTMLElement} */
	var p = this._input;
	while(p) {
		if(p.style.display.toLowerCase() == "none") return false;
		p = p.parentNode;
		if(p.tagName.toUpperCase() == "BODY") break;
	}
	return true;
};


/**
 * applyFilter
 *
 * $type TFun([{ name => text, t => TInst(String,[]), opt => false }],TInst(String,[]))
 * private function applyFilter(text:String):String
 * @private
 * @this com.inq.ui.AbstractTextInput
 * @param {string}  text
 * @return {string}
 */
com.inq.ui.AbstractTextInput.prototype.applyFilter = function (text) {
	/** @type {string} */
	var newText = "";
	/** @type {string} */
	var curChar;
	/** @type {?string} */
	var sRestrict = this.getStyle("restrict");
	if(sRestrict != null) {
		var /** @type {number} */ ix;
		var /** @type {number} */ _g1 = 0, /** @type {number} */ _g = text.length;
		while(_g1 < _g) {
			var /** @type {number} */ ix1 = _g1++;
			curChar = HxOverrides.substr(text,ix1,1);
			if(sRestrict.indexOf(curChar) >= 0) newText += curChar;
		}
	} else newText = text;

	/** @type {?string} */
	var sMaxChars = this.getStyle("maxChars");
	this.maxChars = sMaxChars != null?Std.parseInt(sMaxChars):0;

	if(this.maxChars > 0 && this.maxChars < newText.length) newText = HxOverrides.substr(newText,0,this.maxChars);

	return newText;
};

/**
 * _onFocus
 *
 * $type TFun([{ name => ev, t => TAnonymous(<anonymous>), opt => false },{ name => kev, t => TInst(String,[]), opt => false }],TEnum(Bool,[]))
 * private function _onFocus(ev, kev:String)
 * @private
 * @this com.inq.ui.AbstractTextInput
 * @param {TAnonymous(<anonymous>)}  ev
 * @param {string}  kev
 * @return {boolean}
 */
com.inq.ui.AbstractTextInput.prototype._onFocus = function(ev,kev) {
	/** @type {com.inq.events.KeyboardEvent} */
	var kbe = new com.inq.events.KeyboardEvent(kev);
	if (null != ev) {
		kbe.keyCode = ev.which;
	} else {
		kbe.keyCode = Application.application.getPanelWindow().event.keyCode;
	}
	return this.dispatchEvent(kbe);
};


/**
 * _onKeyUp
 *
 * $type TFun([{ name => ev, t => TAnonymous(<anonymous>), opt => false }],TEnum(Bool,[]))
 * private function _onKeyUp(ev):Bool
 * @private
 * @this com.inq.ui.AbstractTextInput
 * @param {TAnonymous(<anonymous>)}  ev
 * @return {boolean}
 */
com.inq.ui.AbstractTextInput.prototype._onKeyUp = function(ev) {
	try {
		return this._onKey(ev,com.inq.events.KeyboardEvent.KEY_UP);
	} catch( e ) {
	}
	return true;
};


/**
 * _getSelectedText
 *
 * $type TFun([],TInst(String,[]))
 * private function  _getSelectedText():String
 * @private
 * @this com.inq.ui.AbstractTextInput
 * @return {string}
 */
com.inq.ui.AbstractTextInput.prototype._getSelectedText = function() {
	if (this._input["selectionStart"] != null && this._input["selectionEnd"] != null) {
		return this._getInput().substring(this._input.selectionStart,this._input.selectionEnd);
	}
	else if (this._input["createTextRange"] != null && (this.document["selection"] != null && this.document.selection["createRange"])) {
		/** @type {TextRange} */
		var selectionRng = this.document.selection.createRange();
		/** @type {TextRange} */
		var inputRng = this._input.createTextRange();
		if (inputRng != null && selectionRng != null && selectionRng.text.length > 0) {
			/** @type {boolean} */
			var isInRange = inputRng.text.indexOf(selectionRng.text) >= 0;
			if (isInRange) return selectionRng.text;
		}
	}
	return "";
};


/**
 * _onKeyDown
 *
 * private function _onKeyDown(ev):Bool
 * @private
 * @this com.inq.ui.AbstractTextInput
 * @param {object} evt - event object
 * @return {boolean}
 */
com.inq.ui.AbstractTextInput.prototype._onKeyDown = function (evt) {
	if (!evt) {
		evt = Application.application.getPanelWindow().event;
	}
	// If ESC key is pressed and escToClose is configured as true in mxml,
	// return false and let Application.prototype.keydownHandler take action as requested by ComCast
	if (evt.keyCode == com.inq.ui.Keyboard.ESCAPE && com.inq.utils.Util.getConfig("escToClose", false)) {
		return false;
	}

	try {
		return this._onKey(evt, com.inq.events.KeyboardEvent.KEY_DOWN);
	} catch (e) {
	}
	return true;
};


/**
 * _onFocusOut
 *
 * $type TFun([{ name => ev, t => TAnonymous(<anonymous>), opt => false }],TEnum(Bool,[]))
 * private function _onFocusOut(ev)
 * @private
 * @this com.inq.ui.AbstractTextInput
 * @param {TAnonymous(<anonymous>)}  ev
 * @return {boolean}
 */
com.inq.ui.AbstractTextInput.prototype._onFocusOut = function(ev) {
	try {
		if(!this.validateAndFormat()) return false;
		return this._onFocus(ev,com.inq.events.FocusEvent.FOCUS_OUT);
	} catch( e ) {
	}
	return true;
};


/**
 * _onChange
 *
 * $type TFun([{ name => ev, t => TMono(<mono>), opt => false }],TEnum(Bool,[]))
 * private function _onChange(ev):Bool
 * @private
 * @this com.inq.ui.AbstractTextInput
 * @param {TMono(<mono>)}  ev
 * @return {boolean}
 */
com.inq.ui.AbstractTextInput.prototype._onChange = function(ev) {
	return this.validateAndFormat();
};

/**
 * Listen to "paste" event and set flag to mark that text was pasted
 * @private
 * @param {Event} ev
 */
com.inq.ui.AbstractTextInput.prototype._onPaste = function(ev) {
	this.textPasted = true;
};

/**
 * _onFocusIn
 *
 * $type TFun([{ name => ev, t => TAnonymous(<anonymous>), opt => false }],TEnum(Bool,[]))
 * private function _onFocusIn(ev)
 * @private
 * @this com.inq.ui.AbstractTextInput
 * @param {TAnonymous(<anonymous>)}  ev
 * @return {boolean}
 */
com.inq.ui.AbstractTextInput.prototype._onFocusIn = function(ev) {
	try {
		/** @type {boolean} */
		var ret = this._onFocus(ev,com.inq.events.FocusEvent.FOCUS_IN);
		return ret;
	} catch( e ) {
	}
	return true;
};


/**
 * blur - force blur of input field, used to lower the virtual keyboard
 *
 * $type TFun([{ name => ev, t => TAnonymous(<anonymous>), opt => false }],TEnum(Bool,[]))
 * private function _onFocusIn(ev)
 * @public
 * @this com.inq.ui.AbstractTextInput
 * @return {void}
 */
com.inq.ui.AbstractTextInput.prototype.blur = function() {
	if (this._input) {
		this._input.blur();
	}
};


/**
 * _doClick
 *
 * $type TFun([{ name => ev, t => TDynamic(null), opt => false }],TEnum(Bool,[]))
 * private function _doClick(ev:Dynamic)
 * @private
 * @this com.inq.ui.AbstractTextInput
 * @param {null}  ev
 * @return {boolean}
 */
com.inq.ui.AbstractTextInput.prototype._doClick = function (ev) {
	this.setFocus();/*  Set focus to the input text area before hidding the label and image*/

	try {
		/** @type {com.inq.events.MouseEvent} */
		var me = new com.inq.events.MouseEvent(com.inq.events.MouseEvent.CLICK);
		return this.dispatchEvent(me);
	} catch( e ) {
		haxe.Log.trace("ERROR in _doClick",{ fileName : "AbstractTextInput.hx", lineNumber : 732, className : "com.inq.ui.AbstractTextInput", methodName : "_doClick"});
	}
	return true;
};


/**
 * setupInput
 *
 * $type TFun([{ name => input, t => TDynamic(null), opt => false }],TEnum(Void,[]))
 * function setupInput(input:Dynamic)
 * @private
 * @this com.inq.ui.AbstractTextInput
 * @param {null}  input
 * @return {void}
 */
com.inq.ui.AbstractTextInput.prototype.setupInput = function(input) {
	this._input = input;
	this._input.container = this;
	this.clear();
	this._input.oninput = $bind(this,this._onInput);
	this._input.onkeypress = $bind(this,this._onKeyPress);
	this._input.onkeyup = $bind(this,this._onKeyUp);
	this._input.onkeydown = $bind(this,this._onKeyDown);
	this._input.onblur = $bind(this,this._onFocusOut);
	this._input.onfocus = $bind(this,this._onFocusIn);
	this._input.onchange = $bind(this,this._onChange);
	this._div.onclick = $bind(this,this._doClick);
	com.inq.utils.Capabilities.BindListener(this._input, "paste", $bind(this,this._onPaste));
};

/**
 *
 * @param {string=} introduction - can be set through com.inq.ui.SkinLoader.prototype.applyAttributes function.
 * When parameter does not set the value from sIntroduction parameter is used.
 */
com.inq.ui.AbstractTextInput.prototype.setIntroduction = function (introduction) {
	var intro = introduction || com.inq.flash.client.chatskins.SkinControl.getIntroduction();
	if (!this._placeholder && intro != null) {
		this._placeholder = new com.inq.ui.Placeholder(this._input, intro);
	}
};

/**
 * Clear the "placeholder" attribute of the underlying input field.
 *
 * @public
 * @return {void}
 */
com.inq.ui.AbstractTextInput.prototype.clearPlaceholder = function() {
	if (this._placeholder) {
		this._placeholder.clear();
	}
};


com.inq.ui.AbstractTextInput.prototype.cleanUp = function () {
	this._placeholder = null;
};

/**
 * getInput - Accessor for the HTML node attached to this
 * AbstractTextInput.
 *
 * $type TFun([],TDynamic(null))
 * public function getInput():Dynamic
 * @public
 * @this com.inq.ui.AbstractTextInput
 * @return {null}
 */
com.inq.ui.AbstractTextInput.prototype.getInput = function() {
	return this._input;
};

/** @type {boolean} */
com.inq.ui.AbstractTextInput.prototype.disabled = null;
/** @type {string} */
com.inq.ui.AbstractTextInput.prototype.text = null;
/** @type {number} */
com.inq.ui.AbstractTextInput.prototype.maxChars = null;
/** @private @type {string} */
com.inq.ui.AbstractTextInput.prototype._introduction = null;
/** @private @type {?object} */
com.inq.ui.AbstractTextInput.prototype._placeholder = null;
/** @private @type {null} */
com.inq.ui.AbstractTextInput.prototype._input = null;
/** @private @type {String} */
com.inq.ui.AbstractTextInput.prototype.pendingValue = null;
/** @private @type {com.inq.utils.Timer} */
com.inq.ui.AbstractTextInput.prototype.pendingTimer = null;
